import { getVWOExperiment } from '@/helpers/getVWOExperiment'
import { isFeatureEnabled } from './isFeatureEnabled'

export const isFreeShippingExperimentOn = async (mock?: boolean): Promise<boolean> => {
  if (mock) {
    return true
  }
  try {
    const experimentValue = await getVWOExperiment('freeShipping')
    return experimentValue || false
  } catch (error) {
    console.error('VWO Error retrieving free shipping experiment:', error)
    return false
  }
}

export const checkIfFreeShippingEnabled = async () => {
  const freeShippingExperimentOn = await isFreeShippingExperimentOn()
  return isFeatureEnabled('isFreeShippingEnabled') && freeShippingExperimentOn
}
